import { render } from "./ImageContainer.vue?vue&type=template&id=08ddff32"
const script = {}
script.render = render

export default script